<template>
  <v-text-field
    v-bind="$attrs"
    :variant="computedVariant"
    :color="computedColor"
    class="ds-text-field"
  >
    <template v-for="(_, slot) in $slots" v-slot:[slot]="scope">
      <slot :name="slot" v-bind="scope || {}" />
    </template>
  </v-text-field>
</template>

<script setup lang="ts">
import { computed } from 'vue'

export interface DsTextFieldProps {
  /**
   * Variante del campo de texto
   * @default 'outlined'
   */
  dsVariant?: 'outlined' | 'filled' | 'underlined' | 'plain' | 'solo'
  /**
   * Color del campo según el sistema de diseño
   * @default 'primary'
   */
  dsColor?: 'primary' | 'accent' | 'success' | 'error' | 'warning' | 'info'
}

const props = withDefaults(defineProps<DsTextFieldProps>(), {
  dsVariant: 'outlined',
  dsColor: 'primary'
})

const computedVariant = computed(() => props.dsVariant)

const computedColor = computed(() => {
  switch (props.dsColor) {
    case 'accent':
      return 'accent'
    case 'success':
      return 'success'
    case 'error':
      return 'error'
    case 'warning':
      return 'warning'
    case 'info':
      return 'info'
    default:
      return 'primary'
  }
})
</script>

<style scoped lang="scss">
.ds-text-field {
  // Los estilos base están definidos en los defaults de Vuetify
  // Aquí podemos agregar personalizaciones específicas si es necesario
}
</style>
